export const integrationsScimScimInfo = "/integrations/scim/scim_info";
